var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLpCert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.3333 11.6667H53.25C54.8192 11.6667 56.3241 12.2812 57.4337 13.3752C58.5433 14.4692 59.1666 15.9529 59.1666 17.5V58.3333C59.1666 59.8804 58.5433 61.3642 57.4337 62.4581C56.3241 63.5521 54.8192 64.1667 53.25 64.1667H17.75C16.1808 64.1667 14.6759 63.5521 13.5663 62.4581C12.4567 61.3642 11.8333 59.8804 11.8333 58.3333V17.5C11.8333 15.9529 12.4567 14.4692 13.5663 13.3752C14.6759 12.2812 16.1808 11.6667 17.75 11.6667H23.6666",
    fill: "#6D0062"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3333 11.6667H53.25C54.8192 11.6667 56.3241 12.2812 57.4337 13.3752C58.5433 14.4692 59.1666 15.9529 59.1666 17.5V58.3333C59.1666 59.8804 58.5433 61.3642 57.4337 62.4581C56.3241 63.5521 54.8192 64.1667 53.25 64.1667H17.75C16.1808 64.1667 14.6759 63.5521 13.5663 62.4581C12.4567 61.3642 11.8333 59.8804 11.8333 58.3333V17.5C11.8333 15.9529 12.4567 14.4692 13.5663 13.3752C14.6759 12.2812 16.1808 11.6667 17.75 11.6667H23.6666",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.375 5.83334H26.625C24.9912 5.83334 23.6667 7.13918 23.6667 8.75001V14.5833C23.6667 16.1942 24.9912 17.5 26.625 17.5H44.375C46.0089 17.5 47.3334 16.1942 47.3334 14.5833V8.75001C47.3334 7.13918 46.0089 5.83334 44.375 5.83334Z",
    fill: "#6D0062",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLpCert);
export default __webpack_public_path__ + "static/media/LPCert.a5ae074aa6e61b4258c8763b3970eca4.svg";
export { ForwardRef as ReactComponent };